import React, { useEffect, useMemo, useState } from "react";

import { components } from "../components";
import { hooks } from "../hooks";
import { items } from "../items";
import { CategoryItemType } from "../types";

import _ from "lodash";
import { useSelector } from "react-redux";
import constants from "../helpers/constants";
import Enums from "../helpers/enums";
import utils from "../helpers/utils";
import apiService from "../service/ApiService";
import { RootState } from "../store";

export const MenuList: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();
  const category: any = location.state.category;
  const sitesOrderModes = useSelector((state: RootState) => state.appReducer.sitesOrderModes);
  const orderMode = useSelector((state: RootState) => state.appReducer.orderMode);
  const selectedSiteId = useSelector((state: RootState) => state.selectedSiteReducer.selectedSiteId);
  const allSites = useSelector((state: RootState) => state.screenReducer.sites);
  const selectedSite = utils.getSelectedSite(selectedSiteId, allSites);
  const supportedMealSize = selectedSite && selectedSite.supportedMealSize && selectedSite.supportedMealSize.split(',') || [];
  const config = useSelector((state: RootState) => state.appReducer.config);

  const [opacity, setOpacity] = useState<number>(0);
  const [categoryItems, setCategoryItems] = useState<[]>([]);
  const [selectedSize, setSelectedSize] = useState<any>(null);
  const [categoryLoading, setCategoryLoading] = useState<boolean>(true);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor("#F6F9F9", "#F6F9F9", dispatch);

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getItemsByCategory(category.subMenuId)]);
    };
    fetchData();
  }, [category]);

  const filteredCategoryItems = useMemo(() => {
    const menuId = _.find(sitesOrderModes, { orderMode: orderMode })?.menuId;

    if (category.name === "Drinks") {
      const filteredItems = _.filter(categoryItems, (item: any) => {
        const lowercaseName = item.name.toLowerCase();
        return (
          (menuId && item.menuId === menuId) ||
          _.includes(lowercaseName, selectedSize) ||
          _.every(
            constants.refCategorySizes,
            (size) => !_.includes(lowercaseName, size)
          )
        );
      });
      return filteredItems;
    } else if (menuId) {
      return _.filter(categoryItems, (item: any) => item.menuId === menuId);
    }
    return categoryItems;
  }, [selectedSize, items]);

  const getItemsByCategory = async (filterCategory: string) => {
    const { data } = await apiService.getItemsByCategoryAsync(
      selectedSiteId,
      filterCategory,
      false
    );
    if (data) {
      setCategoryItems(data);
      setSelectedSize(Enums.comboSize[supportedMealSize[0] as unknown as keyof typeof Enums.comboSize]);
    }
    setCategoryLoading(false);
  };

  const onChangeSizes = (size: any) => {
    setSelectedSize(size);
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header title="Menu" showGoBack={true} showBasket={true} />
    );
  };

  const renderSize = (): JSX.Element | null => {
    if (category.name !== 'Drinks') {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          marginTop: "16px",
          margin: "16px",
          borderRadius: "25px",
          background: "#f8f9fa",
          overflow: "hidden",
        }}
      >
        {supportedMealSize.map((size: any, index: { toString: () => string | undefined; }) => (
          <button
            id={index.toString()}
            className="t16"
            key={size}
            onClick={() => onChangeSizes(Enums.comboSize[size as unknown as keyof typeof Enums.comboSize])}
            style={{
              flex: 1,
              flexDirection: "row",
              gap: 10,
              alignItems: "center",
              padding: "10px",
              marginBottom: "10px",
              justifyContent: "center",
              border: "none",
              background:
                selectedSize === Enums.comboSize[size as unknown as keyof typeof Enums.comboSize] ? "var(--main-turquoise)" : "#fff",
              color: selectedSize === Enums.comboSize[size as unknown as keyof typeof Enums.comboSize] ? "#fff" : "#333",
              fontWeight: selectedSize === Enums.comboSize[size as unknown as keyof typeof Enums.comboSize] ? 600 : 400,
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
          >
            {_.startCase(Enums.comboSize[size as unknown as keyof typeof Enums.comboSize])}
          </button>
        ))
        }
      </div >
    );
  };

  const renderContent = (): JSX.Element | null => {
    if (categoryLoading || filteredCategoryItems.length === 0) {
      return null;
    }

    return (
      <main className="scrollable">
        <ul className="menu-list">
          {filteredCategoryItems.map(
            (
              categoryItem: CategoryItemType,
              index: number,
              array: CategoryItemType[]
            ) => {
              const isLast = index === array.length - 1;

              return (
                <items.MenuListItem
                  categoryItem={categoryItem}
                  key={categoryItem.menuItemId}
                  isLast={isLast}
                  isShowCalory={config && config.canShowCalory}
                />
              );
            }
          )}
        </ul>
      </main>
    );
  };

  const renderLoader = (): JSX.Element | null => {
    if (categoryLoading || filteredCategoryItems.length === 0) {
      return <components.Loader />;
    }
    return null;
  };

  return (
    <div id="screen" style={{ opacity }}>
      {renderHeader()}
      {renderSize()}
      {renderContent()}
      {renderLoader()}
    </div>
  );
};
